import { campaignsStore } from './modules/campaigns'
import { educationLevelStore } from './modules/education_level'
import { contestGroupStore } from './modules/contest_group'

export default {
  modules: {
    campaigns: { namespaced: true, ...campaignsStore },
    educationLevel: { namespaced: true, ...educationLevelStore },
    contestGroup: { namespaced: true, ...contestGroupStore }
  }
}
